import {SEGMENT_ACTION, SEGMENT_ALIAS} from '../../constants';
import {ISegmentAliasAction} from './types';

export const segmentAliasAction = (userId: string): ISegmentAliasAction => ({
    type: SEGMENT_ACTION,
    case: SEGMENT_ALIAS,
    userId
});
